import { render, staticRenderFns } from "./reportBoxF.vue?vue&type=template&id=8bb74334&scoped=true"
import script from "./reportBoxF.vue?vue&type=script&lang=js"
export * from "./reportBoxF.vue?vue&type=script&lang=js"
import style0 from "./reportBoxF.vue?vue&type=style&index=0&id=8bb74334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb74334",
  null
  
)

export default component.exports